import { createSelector } from '@reduxjs/toolkit';
import { takesDataWithRelationsSelector } from './takes';
import { reduxAssetsDataSelector } from './assets';
import { allActivitiesSelector } from './reduxActivities';
export const tasksReducer = (state) => state.reduxTasks;
export const tasksSelector = createSelector(tasksReducer, (selector) => selector);
export const tasksDataSelector = createSelector(tasksReducer, (selector) => selector.data);
export const allTasksDataSelector = createSelector(tasksReducer, (selector) => selector.allTasks);
export const tasksWithRelationsSelector = createSelector([tasksDataSelector, takesDataWithRelationsSelector, reduxAssetsDataSelector, allActivitiesSelector], (tasks, takes, reduxAssets, activities) => {
    // create relations
    const taskWithRelatedTakes = tasks.map((task) => {
        const relatedTakes = takes.filter((take) => take.task === task.id);
        const relatedAssetInst = reduxAssets.find((asset) => asset.id === task.asset);
        const relatedActivities = activities.filter((activity) => activity.task === task.id);
        return Object.assign(Object.assign({}, task), { takesInst: relatedTakes, assetInst: relatedAssetInst, activitiesInst: relatedActivities });
    });
    return taskWithRelatedTakes;
});
export const flattenTakesFromTasksSelector = createSelector([tasksWithRelationsSelector], (tasks) => {
    const formattedData = tasks.flatMap((task) => {
        return task.takesInst.flatMap((take) => (Object.assign(Object.assign({}, take), { taskInst: task })));
    });
    return formattedData;
});
